export interface ColorVariable {
	light: string;
	default: string;
	accent: string;
	warn: string;
	danger: string;
	contrast: string;
}

export const colorVariables: Record<string, ColorVariable> = {
	deltat: {
		light: 'rgba(92, 119, 255, .1)',
		default: 'rgb(92, 119, 255)',
		accent: 'rgb(255, 64, 129)',
		warn: 'rgb(255, 140, 0)',
		danger: 'rgb(208,33,39)',
		contrast: 'rgb(255, 255, 255)',
	},
	ead: {
		light: 'rgba(219,0,49, 0.1)',
		default: 'rgb(219,0,49)',
		accent: 'rgb(255, 64, 129)',
		warn: 'rgb(255, 140, 0)',
		danger: 'rgb(208,33,39)',
		contrast: 'rgb(255, 255, 255)',
	},
	vertus: {
		light: 'rgba(219,0,49, 0.1)',
		default: 'rgb(204, 0, 51)',
		accent: 'rgb(255, 64, 129)',
		warn: 'rgb(255, 140, 0)',
		danger: 'rgb(208,33,39)',
		contrast: 'rgb(255, 255, 255)',
	},
	arasys: {
		light: 'rgba(21,128,180, 0.1)',
		default: 'rgb(21, 128, 180)',
		accent: 'rgb(68,171,81)',
		warn: 'rgb(255, 140, 0)',
		danger: 'rgb(208,33,39)',
		contrast: 'rgb(255, 255, 255)',
	},
};
